export default __webpack_public_path__ + "static/media/digital-store-product-03.42e6beef.jpg";